<script setup>


const { Settings } = useSettings()
const config = useRuntimeConfig()
const blob = Settings.value.blobIdInHome ? useFetch(`/api/blob/${Settings.value.blobIdInHome}`) : null

useHead({
  title: Settings?.value?.name || 'Blob',
  meta: [
    { property: 'og:title', content: Settings?.value?.name },
    { property: 'og:description', content: Settings?.value?.tagline },
    { property: 'og:url', content: config.public.baseUrl },
    { property: 'og:image', content: config.public.baseUrl + '/media/logo' }
  ],
  link: [
    { rel: 'alternate', type: 'application/rss+xml', title: Settings?.value?.name || 'Blob', href: '/feed' },
    { rel: 'preload', as: 'image', href: '/media/logo' }
  ]
})

</script>

<template>
<div>
  <Blobs id="blob_blobs" />
  <AutoPostList :api="blob ? `/api/post/${Settings.blobIdInHome}` : '/api/post'"
    :pluralistic="blob ? blob.pluralistic : false" />
      
  <p
    v-if="Settings.tagline"
    id="blob_tagline"
    v-html="Settings.tagline"
  />
</div>
</template>

<style>
.theme-Grid .postContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px 15px;
}

.theme-Blob .postContainer .post {
  margin-bottom: 15px;
}

.theme-Blob .postContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
